import { collection, doc } from "firebase/firestore";
import { db } from "@lib/firebase";

// Layout written by the Traka POS app and the signup flow on stocko.io:
//   businesses/{businessId}/business/{businessId}   <- profile (single doc)
//   businesses/{businessId}/settings/{businessId}   <- settings (single doc)
//   businesses/{businessId}/{users|transactions|orders|products|...}
//
// Note the profile and settings docs are single documents inside a
// subcollection whose id repeats the businessId - not fields on the parent.

export const businessCollection = (businessId, name) =>
  collection(db, "businesses", businessId, name);

export const businessProfileRef = (businessId) =>
  doc(db, "businesses", businessId, "business", businessId);

export const businessSettingsRef = (businessId) =>
  doc(db, "businesses", businessId, "settings", businessId);

export const businessUserRef = (businessId, userId) =>
  doc(db, "businesses", businessId, "users", userId);
